<script setup>
import { Link } from '@inertiajs/inertia-vue3'
import stripslashes from '@/Shared/helper.js'
import ButtonFavoriteToggle from '@/Shared/Buttons/ButtonFavoriteToggle'
import ButtonCheckToggle from '@/Shared/Buttons/ButtonCheckToggle'

const props = defineProps({
  category: String,
  type: String,
  item: Object,
})
const slug = (() => {
  if (props.category === 'brand') return props.item.brandSlug
  if (props.category === 'shop') return props.item.shopSlug
})()
const id = (() => {
  if (props.category === 'brand') return props.item.brandID
  if (props.category === 'shop') return props.item.shopID
})()
const name = (() => {
  if (props.category === 'brand') return stripslashes(props.item.brandName)
  if (props.category === 'shop') return stripslashes(props.item.shopNameJ)
})()
const url = (() => {
  if (props.category === 'brand') {
    if (props.item.localWebURL) {
      return props.item.localWebURL
    } else {
      return `/brands/${props.item.brandSlug}`
    }
  }
  if (props.category === 'shop') return `/stores/afcountry/${props.item.shopSlug}`
})()
const style = (() => {
  if (props.category === 'brand') return 'block w-[calc(100%_-_50px)] font-rift font-semibold text-[17px] xs:text-[18px] leading-[1] tracking-wide'
  if (props.category === 'shop') return 'block w-[calc(100%_-_50px)] font-semibold leading-[1.4]'
})()
</script>

<template>
  <div class="py-[10px]">
    <template v-if="props.type === 'favorite'">
      <div :class="style">{{ name }}</div>
      <ButtonFavoriteToggle :data-id="id" class="absolute w-full top-0 right-0 py-[10px]" :category="props.category" :slug="slug" />
    </template>

    <template v-else>
      <template v-if="props.type === 'link'">
        <template v-if="props.item.localWebURL">
          <a :href="url" :class="style" target="_blank">{{ name }}</a>
        </template>
        <template v-else>
          <Link :href="url" :class="style">{{ name }}</Link>
        </template>
      </template>
		  
      <template v-if="props.type === 'check'">
        <ButtonCheckToggle :data-id="id" :category="props.category" :slug="slug" />
        <div :class="style" class="ml-[25px]">{{ name }}</div>
      </template>

      <ButtonFavoriteToggle :data-id="id" class="absolute top-0 right-0 py-[10px] pl-[10px]" :category="props.category" :slug="slug" />
    </template>
  </div>
</template>
